import { FC, useEffect } from 'react';

import ReactJoyride, {
  ACTIONS,
  CallBackProps,
  Step,
  Styles
} from 'react-joyride';
import { useSetRecoilState } from 'recoil';

import { FEATURE_WALKTHROUGH } from 'constants/common';
import { useUpdateUserPreference } from 'services/hooks/TemplateSettings.hooks';
import { featureWalkthrough } from 'store/atoms/authAtom';

import GuideDetails from './GuideDetails/GuideDetails';

type GuideProps = {
  steps: Step[];
  run: boolean;
  finalTooltip: string;
  preferenceKey: string;
};

const CustomStyles: Partial<Styles> = {
  overlay: {
    backgroundColor: 'transparent',
    mixBlendMode: 'normal',
    backgroundBlendMode: 'normal',
    zIndex: 3
  },
  spotlight: {
    backgroundColor: 'transparent',
    borderRadius: '8px',
    boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.75)'
  },
  tooltip: {
    backgroundColor: '#282829A6',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  }
};
const Guide: FC<GuideProps> = ({ steps, run, finalTooltip, preferenceKey }) => {
  const setFeatureWalkthrough = useSetRecoilState(featureWalkthrough);
  const [updateUserPreference] = useUpdateUserPreference();
  //for the tooltip not moving while navbar open & close
  useEffect(() => {
    const modalContainer = document.getElementById('modal-container');

    const observer = new ResizeObserver(() => {
      //trigger resize event for toggle to reposition
      window.dispatchEvent(new Event('resize'));
    });
    observer.observe(modalContainer as HTMLElement, { box: 'border-box' });
    return () => {
      observer.disconnect();
    };
  }, []);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { action, step, lifecycle } = data;

    if (
      action === ACTIONS.NEXT &&
      step.target === finalTooltip &&
      lifecycle === 'complete'
    ) {
      updateUserPreference({
        variables: {
          name: FEATURE_WALKTHROUGH,
          preference: { [preferenceKey]: true }
        },
        onCompleted: () => {
          setFeatureWalkthrough((prev: any) => ({
            ...prev,
            [preferenceKey]: true
          }));
        }
      });
    }
  };

  return (
    <ReactJoyride
      disableOverlayClose={true}
      callback={handleJoyrideCallback}
      steps={steps}
      run={run}
      continuous
      showSkipButton={false}
      hideBackButton
      disableScrolling
      tooltipComponent={GuideDetails}
      disableScrollParentFix
      styles={CustomStyles}
      floaterProps={{ disableAnimation: true }}
    />
  );
};

export default Guide;
